import React from "react";
import { motion } from "framer-motion";

// Renders the agent's `share_progress` calls as inline italic narration —
// a thin gray left-border with italic gray text, similar to a quoted aside.
// Each item fades in as it arrives (driven by ai:progress_text events).

export default function ProgressNarration({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="space-y-1.5">
      {items.map((item) => (
        <motion.div
          key={item.id}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="text-sm italic text-gray-600 leading-relaxed pl-4 border-l-2 border-gray-200"
        >
          {item.text}
          {item.count > 1 && <span className="not-italic text-gray-400"> (×{item.count})</span>}
        </motion.div>
      ))}
    </div>
  );
}
